import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { Console } from 'console';
import { DxChartComponent, DxPieChartComponent, DxPivotGridComponent } from "devextreme-angular";
import { DxiSeriesComponent } from 'devextreme-angular/ui/nested';
import { exportPivotGrid } from 'devextreme/excel_exporter';
import { exportWidgets } from 'devextreme/viz/export';
import { Workbook } from 'exceljs';
import saveAs from 'file-saver';
import { O2ReportFiltersComponent } from '../o2-report-filters.component';

@Component({
  selector: 'O2PortalAwardsByNominalCapacity',
  templateUrl: './o2-portal-asu-awards-by-nominal-capacity.component.html',
  styleUrls: ['./o2-portal-asu-awards-by-nominal-capacity.component.scss']
})
export class O2PortalAsuAwardsByNominalCapacityComponent implements AfterViewInit {
  o2PortalAwardsByNominalCapacityData: any;
  o2PortalAwardsByNominalCapacityBarChartData: any;
  o2PortalAwardsVolumeByNominalASUCapacityBarChartData: any;
  o2PortalAwardsNoOfASUByNominalASUCapacityBarChartData: any;
  o2PortalAwardsByNominalCapacityPieChartData: any;
  colors: Map<string, string>;
  pivotGridNominalASUCapacityAndCompititorDataSource: any;
  resolveOverlappingTypes = ['shift', 'hide', 'none'];
  @ViewChild(O2ReportFiltersComponent) reportFilter;
  @ViewChild("dxNominalCapacityBarChart", { static: false }) dxNominalCapacityBarChart: DxChartComponent;
  @ViewChild("dxVolumeByNominalASUCapacityBarChart", { static: false }) dxVolumeByNominalASUCapacityBarChart: DxChartComponent;
  @ViewChild("dxNoOfASUByNominalASUCapacityBarChart", { static: false }) dxNoOfASUByNominalASUCapacityBarChart: DxChartComponent;
  @ViewChild(DxPieChartComponent, { static: false }) dxPieChart: DxPieChartComponent;
  @ViewChild('VolumeAnalysisByAsuNominalCapacityAndCompetitor', { static: false }) volumeAnalysisByAsuNominalCapacityAndCompetitorGrid: DxPivotGridComponent;
  fromDate: any;
  toDate: any;
  constructor() {
    this.customizeLabel = this.customizeLabel.bind(this);
    this.colors = new Map<string, string>();
  }
  ngAfterViewInit() {
    this.dxNominalCapacityBarChart.instance.render();
    this.dxVolumeByNominalASUCapacityBarChart.instance.render();
    this.dxNoOfASUByNominalASUCapacityBarChart.instance.render();
  }

  getO2PortalAwardsByNominalCapacity(o2PortalAwardsData) {
    this.fromDate = this.reportFilter.fromDate.getFullYear();
    this.toDate = this.reportFilter.toDate.getFullYear();
    this.o2PortalAwardsByNominalCapacityData = o2PortalAwardsData;
    this.colors.clear();
    this.setDataSources();
  }
  setDataSources() {
    this.pivotGridNominalASUCapacityAndCompititorDataSource = {
      fields: [{
        caption: 'TopCompetitors',
        width: 120,
        dataField: 'topCompetitors',
        area: 'row',
      }, {
        dataField: 'asunominalCapacity',
        area: 'column',
      }, {
        groupName: 'asunominalCapacity',
        visible: false,
      }, {
        caption: 'Total',
        dataField: 'totalOxygen',
        dataType: 'number',
        summaryType: 'sum',
        area: 'data',
        format: {
          precision: Number
        }
      }],
      store: this.o2PortalAwardsByNominalCapacityData
    }
    // PieChart
    this.o2PortalAwardsByNominalCapacityData.sort((a, b) => a.asunominalCapacity - b.asunominalCapacity);
    let allArrayData = [... this.o2PortalAwardsByNominalCapacityData].map(item => ({ ...item }));
    allArrayData = allArrayData.reduce((acc, item) => {
      let accItem = acc.find(ai => ai.asunominalCapacity === item.asunominalCapacity);
      if (accItem) {
        accItem.gaseousOxygen = Math.round(accItem.gaseousOxygen + item.gaseousOxygen)
      } else {
        acc.push(item)
      }

      return acc;
    }, []);

    let totalCountArray = [...allArrayData].map(item => ({ ...item }));
    const total = totalCountArray.reduce((prevValue, item) => Math.round(prevValue + item.gaseousOxygen), 0);

    this.o2PortalAwardsByNominalCapacityPieChartData = allArrayData.map((item, index) => {
      let cumulativeCount = item.gaseousOxygen;
      return {
        asunominalCapacity: item.asunominalCapacity,
        cumulativePercent: Math.round(cumulativeCount * 100 / total),
      };
    });

    // Bar Chart1
    this.o2PortalAwardsByNominalCapacityData.sort((a, b) => { return (a.asunominalCapacity - b.asunominalCapacity) || (a.awardYear - b.awardYear) });

    this.o2PortalAwardsByNominalCapacityBarChartData = [... this.o2PortalAwardsByNominalCapacityData].map(item => ({ ...item }));
    this.o2PortalAwardsByNominalCapacityBarChartData.sort((a, b) => {
      if (a.awardYear > b.awardYear) {
        return 1;
      }

      if (a.awardYear < b.awardYear) {
        return -1;
      }

      return 0;
    });
    this.o2PortalAwardsByNominalCapacityBarChartData = this.o2PortalAwardsByNominalCapacityBarChartData.reduce((accm, item) => {

      let accItem = accm.find(ai => ai.asunominalCapacity === item.asunominalCapacity && ai.awardYear === item.awardYear)

      if (accItem) {
        accItem.totalOxygen = Math.round(accItem.totalOxygen + item.totalOxygen);
        accItem.gaseousOxygen = Math.round(accItem.gaseousOxygen + item.gaseousOxygen);
        // To remove comma from long datatype field = converted to string
        accItem.awardYear = accItem.awardYear.toString()
      } else {
        item.awardYear = item.awardYear.toString()
        accm.push(item)
      }

      return accm;
    }, []);


    // Bar Chart2
    this.o2PortalAwardsByNominalCapacityData.sort((a, b) => { return (a.asunominalCapacity - b.asunominalCapacity) || a.process.localeCompare(b.process) });

    this.o2PortalAwardsVolumeByNominalASUCapacityBarChartData = [... this.o2PortalAwardsByNominalCapacityData].map(item => ({ ...item }));
    this.o2PortalAwardsVolumeByNominalASUCapacityBarChartData = this.o2PortalAwardsVolumeByNominalASUCapacityBarChartData.reduce((accm, item) => {
      let accItem = accm.find(ai => ai.asunominalCapacity === item.asunominalCapacity && ai.process === item.process);
      if (accItem) {
        accItem.totalOxygen = Math.round(accItem.totalOxygen + item.totalOxygen)
        // To remove comma from long datatype field = converted to string
        accItem.awardYear = accItem.awardYear.toString()
      } else {
        item.awardYear = item.awardYear.toString()
        accm.push(item)
      }

      return accm;
    }, []);

    // Bar Chart3
    this.o2PortalAwardsByNominalCapacityData.sort((a, b) => { return (a.asunominalCapacity - b.asunominalCapacity) || a.process.localeCompare(b.process) });
    this.o2PortalAwardsNoOfASUByNominalASUCapacityBarChartData = [... this.o2PortalAwardsByNominalCapacityData].map(item => ({ ...item }));
    let capacityAndProcessCount = 1;
    this.o2PortalAwardsNoOfASUByNominalASUCapacityBarChartData = this.o2PortalAwardsNoOfASUByNominalASUCapacityBarChartData.reduce((accm, item) => {
      let accItem = accm.find(ai => ai.asunominalCapacity === item.asunominalCapacity && ai.process === item.process);

      if (accItem) {
        accItem.totalOxygen = Math.round(accItem.totalOxygen + item.totalOxygen);
        accItem.capacityAndProcessCount = ++capacityAndProcessCount;
        // To remove comma from long datatype field = converted to string
        accItem.awardYear = accItem.awardYear.toString()
      } else {
        item.awardYear = item.awardYear.toString()
        item.capacityAndProcessCount = 1;
        capacityAndProcessCount = 1;
        accm.push(item)
      }

      return accm;
    }, []);
  }

  customizeLabel(arg) {
    if (!this.colors.has(arg.argumentText)) {
      this.colors.set(arg.argumentText, arg.point.getColor());
    }
    return `${arg.argumentText} (${arg.percentText})`;
  }

  customizeTooltip(arg: any) {
    return {
      text: `${arg.seriesName} = ${arg.valueText}` + ' mtpd',
    };
  }

  customizeTooltipForNoOfASUs(arg: any) {
    return {
      text: `${arg.seriesName} = ${arg.value}` + ' ASUs',
    };
  }

  onCellPrepared(e) {
    if (e.area === "data" && e.cell.text === "") {
      e.cellElement.textContent = "0";
    }
  }

  customizePoint = (arg: any) => {
    if (this.colors.has(arg.data.asunominalCapacity.toString())) {
      return {
        color: this.colors.get(arg.data.asunominalCapacity.toString()),
        hoverStyle: { color: this.colors.get(arg.data.asunominalCapacity.toString()) }
      };
    }
  }

  exportCharts() {
    const pieChartInstance = this.dxPieChart.instance;
    const dxNominalCapacityBarChart = this.dxNominalCapacityBarChart.instance;
    const dxNoOfASUByNominalASUCapacityBarChart = this.dxNoOfASUByNominalASUCapacityBarChart.instance;
    const dxVolumeByNominalASUCapacityBarChart = this.dxVolumeByNominalASUCapacityBarChart.instance;

    exportWidgets([[pieChartInstance, dxNominalCapacityBarChart],
    [dxNoOfASUByNominalASUCapacityBarChart],
    [dxVolumeByNominalASUCapacityBarChart]], {
      fileName: "ASUAwards_ByNominalCapacity_ChartReport",
      format: "PNG"
    });
  }

  exportExcel(e) {
    const context = this;
    const workbook = new Workbook();
    const regwb = workbook.addWorksheet('ASU Nominal Capacity And Competitor');

    exportPivotGrid({
      worksheet: regwb,
      component: context.volumeAnalysisByAsuNominalCapacityAndCompetitorGrid.instance,

    }).then(() => {
      workbook.xlsx.writeBuffer().then((buffer) => {
        saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'ASU_Awards_By_ASUNominalCapacity.xlsx');
      });
    });
  }

}
